import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { RecordStatus } from "@/components/shared/entity/recordStatus";
import { type CulturalActivity, getActivitiesForIncentive } from "@/domain/beneficiary";
import type { TaxIncentiveTypeValue } from "@/domain/classification/constants";
import { ACTIVITIES, POSITION_OPTIONS } from "../config/beneficiaryCatalog";
import { ACTIVITY_TONE } from "../config/beneficiaryDisplay";
import type { VerticalOption } from "../components/VerticalCell";

export function usePromoterLabels() {
  const { t } = useTranslation();
  return useMemo(() => {
    const activities: VerticalOption<CulturalActivity>[] = ACTIVITIES.map((activity) => ({
      value: activity.value,
      label: t(activity.labelKey),
      tone: ACTIVITY_TONE[activity.value],
    }));
    const activitiesFor = (incentive: TaxIncentiveTypeValue | null | undefined) => {
      const allowed = getActivitiesForIncentive(incentive);
      return activities.filter((option) => allowed.includes(option.value));
    };
    const statusLabels: Record<RecordStatus, string> = {
      active: t("record_status.active"),
      inactive: t("record_status.inactive"),
      archived: t("record_status.archived"),
    };
    const positions = POSITION_OPTIONS.map((option) => ({
      value: option.value,
      label: t(option.labelKey),
    }));
    return { activities, activitiesFor, statusLabels, positions };
  }, [t]);
}
